import moment from "moment";

export const getUserType = (u) => {
  const accType = (u.account_type || "").toLowerCase();
  const userRole = (u.role || "").toLowerCase();
  if (accType === "coaching") return "coaching";
  if (accType === "other") return "other";
  if (userRole === "general_user") return "General User";
  if (userRole === "teacher") return "teacher";
  if (userRole === "student") return "student";
  if (userRole === "user") return "School User";
  return "school";
};

export const getRegStatus = (u) => {
  return u.is_mobile === 1 && u.is_email === 1 ? "verified" : "incomplete";
};

export const getSubStatus = (u) => {
  const plans = Array.isArray(u.payments) ? u.payments.filter(Boolean) : [];
  const now = moment();
  if (plans.length === 0) {
    const isExpired =
      u.trial_period_end_time &&
      now.isSameOrAfter(moment(u.trial_period_end_time));
    return isExpired ? "expired" : "trial";
  }
  const plan = plans[0];
  const isPlanExpired =
    plan.created_at &&
    now.isSameOrAfter(moment(plan.created_at).add(365, "days"));
  return isPlanExpired ? "expired" : "paid";
};

// Sets all AppD AI window variables from user object
// pageContext: "general" | "login" | "registration" | "pricing" | "demo"
export const setAppdAiUser = (u, pageContext = "general") => {
  window.__mdm_user_phone = u.contact_number || "";
  window.__mdm_user_name = u.admin_name || "";
  window.__mdm_user_type = getUserType(u);
  window.__mdm_reg_status = getRegStatus(u);
  window.__mdm_sub_status = getSubStatus(u);
  window.__mdm_page_context = pageContext;
  // debugAppdAi("setAppdAiUser");
};

// For non-logged-in pages — only sets page context with unknown user
export const setAppdAiGuest = (pageContext = "general") => {
  window.__mdm_user_phone = "";
  window.__mdm_user_name = "";
  window.__mdm_user_type = "unknown";
  window.__mdm_reg_status = "";
  window.__mdm_sub_status = "";
  window.__mdm_page_context = pageContext;
  // debugAppdAi("setAppdAiGuest");
};

// DEBUG: logs all AppD AI window variables (remove after testing)
const debugAppdAi = (caller) => {
  console.log(`===========APPD_AI_DEBUG [${caller}]===========`);
  console.log("__mdm_user_phone:", window.__mdm_user_phone);
  console.log("__mdm_user_name:", window.__mdm_user_name);
  console.log("__mdm_user_type:", window.__mdm_user_type);
  console.log("__mdm_reg_status:", window.__mdm_reg_status);
  console.log("__mdm_sub_status:", window.__mdm_sub_status);
  console.log("__mdm_page_context:", window.__mdm_page_context);
  console.log("===============================================");
};

// Clears all AppD AI window variables (call on logout)
export const clearAppdAiUser = () => {
  window.__mdm_user_phone = "";
  window.__mdm_user_name = "";
  window.__mdm_user_type = "";
  window.__mdm_reg_status = "";
  window.__mdm_sub_status = "";
  window.__mdm_page_context = "general";
};
